// Guarda de acceso del Panel Super Admin. Es deliberadamente una capa de
// EXPERIENCIA (evita mostrarle a alguien sin permiso una pantalla vacía o
// con errores de Supabase), no la capa de seguridad real — esa es RLS
// (20260101000006_seguridad_rls.sql), que rechaza cualquier consulta igual
// si alguien se salta esta guarda editando el JS del navegador. Ver 7.1 del
// doc de arquitectura general.

import { navegarA } from './enrutador.js';
import { obtenerEstadoSesion } from './estado-sesion.js';

/**
 * Verifica que haya una sesión activa con rol `super_admin`. Si no la hay,
 * redirige a `/login` y devuelve `false` — el llamador (cada vista
 * protegida) debe cortar su propio renderizado cuando esto devuelve `false`.
 *
 * @returns {boolean}
 */
export function exigirSuperAdmin() {
  const { sesion, claims } = obtenerEstadoSesion();

  if (!sesion) {
    navegarA('/login');
    return false;
  }

  if (claims.rol !== 'super_admin') {
    // Sesión válida pero de otro rol (o el Auth Hook aún no corrió sobre
    // este token — ver ADR-0005): no es un caso de "credenciales
    // inválidas", así que no se manda a /login, se informa directamente.
    navegarA('/sin-permiso');
    return false;
  }

  return true;
}
